import CountUp from "react-countup";

type CounterProps = {
  number?: number;
  duration?: number;
};

export default function Counter({ number = 0.0, duration = 0 }: CounterProps) {
  return (
    <>
      <CountUp
        end={number}
        duration={duration}
        suffix="%"
        separator=" "
        decimals={2}
        decimal=","
      ></CountUp>
    </>
  );
}
